export default __webpack_public_path__ + "static/media/transEnd.2780754e.png";